import React from 'react';
import clsx from 'clsx';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
/**
 * Accordion Body Component
 * @param children {React.ReactNode} Children for Accordion body
 * - ------------------ WEB PROPERTIES -----------------------
 * @param className {string} Additionnal CSS Classes
 * @param contentClassName {string} Additionnal CSS Classes for accordion-content
 */
const AccordionBody = ({ children, className, dataId, testId, active, ...others }) => {
    const { styled } = useTrilogyContext();
    return (React.createElement("div", { "data-accordion-body": true, "data-id": dataId, "data-testid": testId, className: hashClass(styled, clsx('accordion-body is-clipped', className)), onClick: (e) => {
            e.stopPropagation();
        }, ...others },
        React.createElement("div", { className: hashClass(styled, clsx('accordion-content')) }, children)));
};
export default AccordionBody;
//# sourceMappingURL=AccordionBody.js.map